import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyUser, HttpResponse } from "@/types";

export function useGetCompanyUsersForSettings() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["settings/company-users", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/settings/users`;
      const res = await guacHttpClient.get<
        CompanyUser[],
        HttpResponse<CompanyUser[]>
      >(path);
      return res.data;
    },
  });
}
